<template>
  <v-sheet>
    <v-container class="py-0">
      <v-responsive class="mx-auto">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12" lg="6" md="6" class="pr-5 pt-2">
              <div class="div-bg rounded-lg pa-4 position-relative overflow-hidden mt-md-0 mt-6 badge-rounded">
                <h2 class="text-20 font-weight-bold mb-2 text-white ">Reach Out Today</h2>
                <v-divider class="my-2 white opacity-20"></v-divider>
                <div>Have questions or need assistance?</div>
                <v-divider class="my-2 hidden"></v-divider>
                <div>Let us know! We're just a message away.</div>
                <v-divider class="my-2 hidden"></v-divider>
                <div class="font-weight-bold">{{ contactName }}</div>
                <div><span class="font-weight-bold">Phone:</span> {{ contactPhone }}</div>
                <div><span class="font-weight-bold">Email:</span> {{ contactEmail }}</div>
              </div>

              <div class="mt-8 text-md-body-1 font-weight-bold">Need to start a claim?</div>
              <p>
                Please locate your coverage under <strong>Manager Coverage</strong> and follow the steps or call 
                <strong>{{ contactPhone }}</strong> to report or begin the process.
              </p>
            </v-col>

            <v-col cols="12" md="6" lg="6">
              <v-form ref="form" v-model="valid" :disabled="sent" class="my-2">
                <v-text-field v-model="form.name" :rules="requiredRule" label="Name" outlined></v-text-field>
                <v-text-field v-model="form.email" :rules="requiredRule" label="Email" outlined></v-text-field>
                <v-text-field v-model="form.phone" :rules="requiredRule" label="Phone" outlined></v-text-field>
                <v-text-field v-model="form.policy" label="Policy (if applicable)" outlined></v-text-field>
                <v-textarea v-model="form.message" :rules="requiredRule" label="Message" outlined></v-textarea>
                
                <v-btn
                  :disabled="sent"
                  :loading="loading"
                  submit
                  large
                  block
                  color="secondary"
                  min-width="180"
                  @click="sendContact"
                >
                  Send
                </v-btn>
              </v-form>

              <v-alert v-if="errorMessage" dense outlined type="error">
                {{ errorMessage }}
              </v-alert>

              <v-alert v-if="sent" dense text type="success">
                Message sent
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-responsive>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from 'vuex'
import { sendRequest } from '@/configs/requests'

export default {
  data: () => ({
    loading: false,
    sent: false,
    errorMessage: null,
    valid: true,
    form: {
      name: '',
      email: '',
      phone: '',
      policy: '',
      message: ''
    }
  }),
  computed: {
    ...mapState({
      meta: (state) => state.microsite.meta
    }),
    contactPhone() {
      return this.meta.custom_phone
    },
    contactEmail() {
      return this.meta.custom_email
    },
    contactName() {
      return this.meta.custom_name
    },
    requiredRule() {
      return [(v) => !!v || 'Field required']
    }
  },
  methods: {
    async sendContact() {
      this.errorMessage = null

      if (this.valid) {
        this.loading = true
        try {
          await sendRequest('microsite/contact', 'POST', this.form)
          this.sent = true
          this.$refs.form.reset()
        } catch {
          this.errorMessage = 'Error sending message'
        }
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.badge-rounded {
    background-color: #a51d32;
    color: white;
    font-size: 16px;
    line-height: 26px;
    font-weight: 400 !important;
}
.white {
    color: white;
}
.hidden {
  opacity: 0;
}
.opacity-20 {
  opacity: 0.2;
}
</style>